export default {
    imageAIFormRules: {
        enterDescription: 'Veuillez saisir la description',
        invalidDescription: 'Veuillez saisir une description valide',
        enterNumberOfVariations: 'Veuillez sélectionner le nombre de variations',
        invalidNumberOfVariations: 'Vous pouvez générer un maximum de 4 variations et un minimum de 1',
        enterStyle: 'Veuillez sélectionner au moins un style',
    },
};
